// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__9zVGH","colMin":"styles_colMin__2DWRF","colCheckbox":"styles_colCheckbox__3xG5z"};